import { render, staticRenderFns } from "./PageError403.vue?vue&type=template&id=4546d410&scoped=true&"
import script from "./PageError403.vue?vue&type=script&lang=js&"
export * from "./PageError403.vue?vue&type=script&lang=js&"
import style0 from "./PageError403.vue?vue&type=style&index=0&id=4546d410&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4546d410",
  null
  
)

export default component.exports